import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff, AlertCircle, ArrowLeft } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin/dashboard');
    } catch {
      setError('Email atau password salah.');
    } finally {
      setLoading(false);
    }
  };

  const inp = {
    background: 'rgba(0,0,0,0.4)',
    border: '1px solid rgba(255,255,255,0.1)',
    color: '#f2f2ff',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 14,
    borderRadius: 3,
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, position: 'relative', overflow: 'hidden',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      {/* Grid bg */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)',
        backgroundSize: '48px 48px', pointerEvents: 'none',
      }} />

      <div style={{
        width: '100%', maxWidth: 420, position: 'relative', zIndex: 1,
        background: 'var(--card)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 4,
      }}>
        {/* Holo top line */}
        <div style={{ height: 2, background: 'linear-gradient(90deg, #00e5ff, #9b00ff, #ff0099, #ffb700)', borderRadius: '4px 4px 0 0' }} />

        <div style={{ padding: '40px 36px' }}>
          {/* Header */}
          <div style={{ marginBottom: 36 }}>
            <div style={{
              fontFamily: "'DM Mono', monospace",
              fontSize: 11, color: '#6a6a88', letterSpacing: 3,
              textTransform: 'uppercase', marginBottom: 10,
            }}>ADMIN PANEL</div>
            <h1 style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 700, fontSize: 28, color: '#f2f2ff',
              margin: '0 0 6px', letterSpacing: '-0.5px',
            }}>Masuk</h1>
            <p style={{ fontSize: 13, color: '#6a6a88', margin: 0 }}>Kelola website erwinpaisal.id</p>
          </div>

          {/* Error */}
          {error && (
            <div style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '12px 14px',
              background: 'rgba(239,68,68,0.08)',
              border: '1px solid rgba(239,68,68,0.2)',
              borderRadius: 3, marginBottom: 20,
            }}>
              <AlertCircle size={14} color='#ef4444' />
              <span style={{ fontSize: 13, color: '#ef4444' }}>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <Label style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, letterSpacing: 2, color: '#6a6a88', display: 'block', marginBottom: 8 }}>EMAIL</Label>
              <div style={{ position: 'relative' }}>
                <Mail size={13} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#6a6a88' }} />
                <Input type='email' value={email} onChange={e => setEmail(e.target.value)}
                  placeholder='' required
                  style={{ ...inp, paddingLeft: 36 }}
                  onFocus={e => e.target.style.borderColor = 'rgba(0,229,255,0.4)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'} />
              </div>
            </div>

            <div style={{ marginBottom: 28 }}>
              <Label style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, letterSpacing: 2, color: '#6a6a88', display: 'block', marginBottom: 8 }}>PASSWORD</Label>
              <div style={{ position: 'relative' }}>
                <Lock size={13} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#6a6a88' }} />
                <Input type={showPass ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
                  placeholder='' required
                  style={{ ...inp, paddingLeft: 36, paddingRight: 44 }}
                  onFocus={e => e.target.style.borderColor = 'rgba(0,229,255,0.4)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'} />
                <button type='button' onClick={() => setShowPass(!showPass)}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#6a6a88', padding: 0 }}>
                  {showPass ? <EyeOff size={14} /> : <Eye size={14} />}
                </button>
              </div>
            </div>

            <button type='submit' disabled={loading}
              style={{
                width: '100%', padding: '13px', borderRadius: 3,
                background: loading ? 'rgba(255,255,255,0.05)' : 'linear-gradient(135deg, #00e5ff, #9b00ff)',
                color: loading ? '#6a6a88' : '#07070f',
                fontFamily: "'Space Grotesk', sans-serif",
                fontWeight: 700, fontSize: 13, border: 'none',
                cursor: loading ? 'not-allowed' : 'pointer',
                letterSpacing: 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                transition: 'opacity 0.2s',
              }}
              onMouseEnter={e => { if (!loading) e.currentTarget.style.opacity = '0.88'; }}
              onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
            >
              {loading ? (
                <><div style={{ width: 14, height: 14, border: '2px solid transparent', borderTopColor: '#6a6a88', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} /> MASUK...</>
              ) : 'MASUK'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <a href='/' style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontFamily: "'DM Mono', monospace", fontSize: 11, color: '#6a6a88', textDecoration: 'none', letterSpacing: 1, transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#f2f2ff'}
              onMouseLeave={e => e.currentTarget.style.color = '#6a6a88'}>
              <ArrowLeft size={12} /> KEMBALI KE WEBSITE
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
